import gql from "graphql-tag";

const PAGE_QUERY = gql`  
  query Page($pageId: String!){
  page(id: $pageId) {
        id
        slug
        title
        body
        parent { 
          id
          slug
        }
        children {
          id
          slug
        }
        updatedAt
        createdAt
        published
        galleries{
          id
          name
          description
          items{
            id
            url
            image{
              id
              original
              thumbnail
              zoom
            }
            product {
              id
              name
              description
              code
              cost
              image{
                  original
                  thumbnail
                  zoom
              }
              maxQty
              stepQty
              startDate
              endDate
            }
            label
            description
            type
            startDate
            endDate
          }
          internalOnly
          displayOrder
        }
    }
  }
`;

export default PAGE_QUERY;